import React from "react";
import "./index.css";
import "react-toastify/dist/ReactToastify.css";
import Home from "./routes/Home.js"
import About from "./routes/About.js"
import Contact from "./routes/Contact.js"
import {Route, Routes} from "react-router-dom"
//import { BrowserRouter, Switch, redirect } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import MeetTheTeam from "./routes/MeetTheTeam.js";
import SignUp from "./routes/SignUp.js";
import Gallery from "./routes/Gallery.js";


function App() {
  
  return (
    <>
    <ToastContainer/>
    <Routes>
      <Route path="/" exact element={<Home />} />
      <Route path="/about" element={<About />} />
      <Route path="/contact" element={<Contact />} />
      <Route path = "/team" element = {<MeetTheTeam/>} />
      <Route path = "/signup" element = {<SignUp/>} />
      <Route path = "/gallery" element = {<Gallery/>} />
      
      
    </Routes>
    </>
  );
}

export default App;
